module.exports = __webpack_public_path__ + "img/oski-logo.d6335195.jpg";